'use client'

import { TrashBin24 } from '@vinted/monochrome-icons'
import { Cell, Icon, Note } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import DeleteConversationModal from '../DeleteConversationModal'

type Props = {
  conversationId: number | string
  onActionClick: () => void
  onCancel: () => void
  onConfirm: () => void
  restricted: boolean
  showModal: boolean
}

const DeleteConversationAction = ({
  conversationId,
  onActionClick,
  onCancel,
  onConfirm,
  restricted,
  showModal,
}: Props) => {
  const translate = useTranslate()

  // TODO: replace the `Cell` with `Button` so we don't have to manage `aria-disabled` and `tabIndex` manually
  return (
    <>
      <Cell
        title={translate('conversation.conversation_info.conversation_actions.delete')}
        prefix={<Icon name={TrashBin24} color="warning-default" />}
        type="navigating"
        onClick={onActionClick}
        testId="conversation-actions-delete"
        disabled={restricted}
        tabIndex={restricted ? -1 : 0}
        aria={{ 'aria-disabled': restricted }}
      />
      {restricted && (
        <Note
          text={translate('conversation.conversation_info.conversation_actions.appeal_delete_note')}
        />
      )}
      <DeleteConversationModal
        conversationId={conversationId}
        show={showModal}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </>
  )
}

export default DeleteConversationAction
